import React, { useEffect } from 'react'; // Agregamos useEffect aquí
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom'; // Agregamos useLocation
import { AppAgendaProvider } from './context/AppAgendaContext';

// Importaciones de tus páginas...
import IndexPac from './pages/IndexPac';
import SeleccionaTipoHora from './pages/SeleccionaTipoHora';
import SeleccionaEspSuc from './pages/SeleccionaEspSuc';
import SeleccionaProfSuc from './pages/SeleccionaProfSuc';
import SeleccionaFecHora from './pages/SeleccionaFecHora';
import ConfirmaFonoMail from './pages/ConfirmaFonoMail';
import ConfirmaPaciente from './pages/ConfirmaPaciente';
import ConfirmaAgendamiento from './pages/ConfirmaAgendamiento';
import DebugPanel from './components/DebugPanel';

// 1️⃣ CREAMOS ESTE SUB-COMPONENTE "INVISIBLE"
const MetaPixelTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (window.fbq) {
      window.fbq('track', 'PageView');
    }
  }, [location]);

  return null; // No renderiza nada visualmente
};

function App() {
  return (
    <AppAgendaProvider>
      <Router basename="/agenda">
        {/* 2️⃣ LO COLOCAMOS AQUÍ, DENTRO DEL ROUTER */}
        <MetaPixelTracker /> 

        <Routes>
          <Route path="/" element={<IndexPac />} />
          <Route path="/IndexPac" element={<IndexPac />} />
          <Route path="/SeleccionaTipoHora" element={<SeleccionaTipoHora />} />
          <Route path="/SeleccionaEspSuc" element={<SeleccionaEspSuc />} />
          <Route path="/SeleccionaProfSuc" element={<SeleccionaProfSuc />} />
          <Route path="/SeleccionaFecHora" element={<SeleccionaFecHora />} />
          <Route path="/ConfirmaFonoMail" element={<ConfirmaFonoMail />} />
          <Route path="/ConfirmaPaciente" element={<ConfirmaPaciente />} />
          <Route path="/ConfirmaAgendamiento" element={<ConfirmaAgendamiento />} />
        </Routes>
      </Router>

      { process.env.NODE_ENV !== 'production' && <DebugPanel /> }
    </AppAgendaProvider>
  );
}

export default App;